exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".flow-containers .el-badge__content.is-fixed {\n  top: 0.09375rem;\n}", ""]);

// exports
